import { ReactNode } from 'react'
import { Loading } from '../Loading/Loading'
import { ButtonCard } from '../ButtonCard/ButtonCard'
import {
  CardIconTitle,
  CardIconTitleProps,
} from '../CardIconTitle/CardIconTitle'
import { GenericTable } from '../GenericTable/GenericTable'
import {
  ButtonCardStyle,
  CardTopo,
  Container,
  Wrapper,
} from './TableSection.style'

type TableSectionProps = CardIconTitleProps & {
  children: ReactNode
  headers: string[]
  isOnHigh: boolean
  changeValue: () => void
  isLoading: boolean
  text?: boolean
  vendas?: boolean
}

export function TableSection({
  title,
  background,
  icon,
  children,
  headers,
  isOnHigh,
  changeValue,
  isLoading,
  text,
  vendas,
}: TableSectionProps) {
  return (
    <Container>
      <Wrapper>
        <CardTopo>
          <CardIconTitle title={title} icon={icon} background={background} />
          <ButtonCardStyle>
            <ButtonCard isOnHigh={isOnHigh} changeValue={changeValue} />
          </ButtonCardStyle>
        </CardTopo>
        <GenericTable
          vendas={vendas}
          spacing="20px"
          headers={headers}
          font="16px"
          text={text}
        >
          {isLoading ? (
            <tr>
              <td colSpan={headers.length}>
                <Loading contrast={false} />
              </td>
            </tr>
          ) : (
            children
          )}
        </GenericTable>
      </Wrapper>
    </Container>
  )
}
